var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cases-shell",class:{ 'cases-dark-theme': _vm.theme == 'dark' },attrs:{"id":"main-app"}},[_c('CasesContent',[_c('nuxt')],1),_vm._v(" "),_c('CasesMenu'),_vm._v(" "),_c('client-only',[_c('Feed-socket'),_vm._v(" "),_c('Toasts'),_vm._v(" "),_c('BoostPanel')],1),_vm._v(" "),_c('portal-target',{attrs:{"name":"cinema"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }